module.exports = "<div class=c-search-page__status :class=\"{'c-search-page__status--standalone': standalone}\"> <template v-if=\"state == 'NO_RESULTS' || state == 'ERROR' || state == 'UNKNOWN'\"> {{ trans(\"No results found\") }} </template> <template v-else-if=\"state == 'INITIAL_LOADING'\"> {{ trans(\"Loading\") }}... </template> <template v-else> {{ trans(\"Showing {x} of {y} Results\").replace(\"{x}\", currentResults).replace(\"{y}\", totalResults) }} </template> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/pages/explore-the-archive/archive/templates/status.html
// module id = 152
// module chunks = 0